import {
    ExclamationIcon, TrashIcon, UserIcon,
} from 'components/Icon'

import {
    FieldValues,
    SubmitHandler, useForm,
} from 'react-hook-form'

import {
    ModalContent,
    ModalFooter,
    ModalHeader,
} from '../ModalView'

import Button from 'components/Button'
import {Identity} from 'api/types/properties'
import {IdentityModalTypes} from 'actions/modal/types'

import Modal from '../Modal'
import React from 'react'

import {isEmail} from 'utils/email'
import {styled} from 'stitches/config'
import {styledInputFullWidth} from './styles/IdentityModal.styles'
import {
    styledLabel,
} from 'components/Form/styles/FormView'

import {
    useTranslation,
} from 'react-i18next'

export interface IdentityModalViewProps {
    handleClose: () => void
    handleCancel: () => void
    handleAction: (data: {
        password?: string;
        newPassword?: string;
        email?: string
    }) => void,
    identity: Identity,
    type: IdentityModalTypes

}

const StyledInputFullWidth = styled('input', styledInputFullWidth)
const StyledLabel = styled('label', styledLabel)

const IdentityModalView = ({
    handleClose,
    handleCancel,
    handleAction,
    identity,
    type,
}: IdentityModalViewProps): React.ReactElement => {
    const {t} = useTranslation()
    const {
        register, handleSubmit, formState,
    } = useForm({mode: 'onChange'})

    const onSubmit: SubmitHandler<FieldValues> = (data) => {
        const {
            password, email, newPassword,
        } = data

        if (type === IdentityModalTypes.remove) {
            handleAction({password})
        } else if (type === IdentityModalTypes.add) {
            handleAction({
                email,
                newPassword,
            })
        } else if (type === IdentityModalTypes.changePassword) {
            handleAction({
                newPassword,
                password,
            })
        }
    }

    return (
        <Modal onClose={handleClose}>
            <form onSubmit={handleSubmit(onSubmit)}>
                {type === IdentityModalTypes.changePassword && (
                    <div>
                        <ModalHeader icon={UserIcon} title={t('Change password')} type='success' />
                        <ModalContent>
                            <div>
                                <div>{t('Change password for identity:')} <strong>{identity.name}</strong> </div>
                                <br />
                                <StyledLabel htmlFor='password'>{t('To verify, type old password')}</StyledLabel>
                                <StyledInputFullWidth
                                    {...register('password', {required: true})}
                                    id='password'
                                    placeholder={t('Old password')}
                                    tabIndex={0}
                                    type='password'
                                />
                                <StyledLabel htmlFor='newPassword'>{t('New password')}</StyledLabel>
                                <StyledInputFullWidth
                                    {...register('newPassword', {
                                        minLength: 12,
                                        required: true,
                                    })}
                                    id='newPassword'
                                    placeholder={t('At least 12 characters')}
                                    tabIndex={0}
                                    type='password'
                                />
                                <br />
                            </div>
                        </ModalContent>
                        <ModalFooter>
                            <Button onPress={handleCancel} tabIndex={0} text={t('Cancel')} />
                            <Button color='filled' disabled={!formState.isValid} margin='left' tabIndex={0} text={t('Change')} type='submit' />
                        </ModalFooter>
                    </div>)}
                {type === IdentityModalTypes.add && (
                    <div>
                        <ModalHeader icon={UserIcon} title={t('Add new identity')} type='success' />
                        <ModalContent>
                            <div>
                                <div>{t('Create new authentication method by adding new email address and password. After creation, check your inbox for verification email.')}</div>
                                <StyledLabel htmlFor='email'>{t('Email address')}</StyledLabel>
                                <StyledInputFullWidth
                                    {...register('email', {validate: (value) => isEmail(value) || false})}
                                    id='email'
                                    placeholder={t('New login email')}
                                    tabIndex={0}
                                    type='text'

                                />
                                <StyledLabel htmlFor='newPassword'>{t('Password')}</StyledLabel>
                                <StyledInputFullWidth
                                    {...register('newPassword', {
                                        minLength: 12,
                                        required: true,
                                    })}
                                    id='newPassword'
                                    placeholder={t('At least 12 characters')}
                                    tabIndex={0}
                                    type='password'

                                />
                                <br />
                            </div>
                        </ModalContent>
                        <ModalFooter>
                            <Button onPress={handleCancel} tabIndex={0} text={t('Cancel')} />
                            <Button color='filled' disabled={!formState.isValid} margin='left' tabIndex={0} text={t('Add')} type='submit' />
                        </ModalFooter>
                    </div>)}
                {type === IdentityModalTypes.remove && (
                    <div>
                        <ModalHeader icon={ExclamationIcon} title={t('Remove identity')} type='error' />
                        <ModalContent>
                            <div>
                                <div>{t('Are you sure you want to remove identity')} <strong>{identity.name} </strong>
                                </div>
                                <br />
                                <div>{t('If you are sure, enter your password and click Remove.')}</div>

                                <StyledLabel htmlFor='password'>{t('Password')}</StyledLabel>
                                <StyledInputFullWidth
                                    {...register('password', {required: true})}
                                    id='password'
                                    placeholder={t('Password')}
                                    tabIndex={0}
                                    type='password'
                                />
                            </div>
                        </ModalContent>
                        <ModalFooter>
                            <Button onPress={handleCancel} tabIndex={0} text={t('Cancel')} />
                            <Button color='filled' disabled={!formState.isValid} iconLeft={TrashIcon} margin='left' tabIndex={0} text={t('Remove')} type='submit' />
                        </ModalFooter>
                    </div>)}
            </form>
        </Modal>
    )
}

export default IdentityModalView

